<h1 mat-dialog-title>Erro</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Fechar</button>
</div>
